module.exports = __webpack_public_path__ + "img/section-number-commande.4b07fe57.svg";